import { defineStore } from 'pinia';
import { db } from '@/firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import { BETTYPES_DB, BET_TYPE_LIST_PICKER } from '@/constants/constants';
import { useUserStore } from '@/stores/users';

export const useBetTypesStore = defineStore('betTypes', {
  state: () => ({
    bettypeslist: []
  }),
  actions: {
    async createBetTypesList() {
      const userStore = useUserStore();
      const currentUser = userStore.userid;
      try {
        const snapshot = await getDocs(collection(db, BETTYPES_DB));
        if (snapshot.empty) {
          // Collection not seeded yet — fall back to built-in constants
          this.bettypeslist = [...BET_TYPE_LIST_PICKER];
          return;
        }
        const list = [];
        snapshot.forEach(doc => {
          const data = doc.data();
          if (data.global || data.addedby === currentUser) {
            list.push(data.name);
          }
        });
        this.bettypeslist = list.length ? list : [...BET_TYPE_LIST_PICKER];
      } catch (error) {
        console.error('Error fetching bet types:', error);
        this.bettypeslist = [...BET_TYPE_LIST_PICKER];
      }
    }
  }
});
